// https://developer.mozilla.org/en-US/docs/Learn/JavaScript/Objects/Inheritance

class User_Info {
	constructor(data) {
		if (empty(data)) data = {}

		sdp(this, data, 'user_id', 0)
		sdp(this, data, 'first_name', '')
		sdp(this, data, 'last_name', '')
		sdp(this, data, 'email', '')
		sdp(this, data, 'organization', '')
		sdp(this, data, 'system_role', '', ['', 'admin', 'editor', 'reviewer'])

		// if allow_to_create_frameworks_for_category is set to a non-empty string, it means the user is allowed to create frameworks for one particular category; 
		// that category abbreviation will be coded by allow_to_create_frameworks_for_category
		sdp(this, data, 'allow_to_create_frameworks_for_category', '')

		// if category_access is set to a non-empty string, it means the user is only allowed to download frameworks for the specified categories
		// note that this could be a comma-separated list; store.getters will convert to an array
		sdp(this, data, 'category_access', '')

		// for recording which comments the user has read: translate from format "5,6,10,23" to {5:1, 6:1, 10:1, 23:1}
		this.comment_reads = {}
		if (!empty(data.comment_reads)) {
			let arr = data.comment_reads.split(',')
			for (let comment_id of arr) this.comment_reads[comment_id] = 1
		}

		// framework notification settings
		this.notification_settings = {}
		if (!data.notification_settings) data.notification_settings = {}
		sdp(this.notification_settings, data.notification_settings, 'on', 'no')
		sdp(this.notification_settings, data.notification_settings, 'email', this.email)
		sdp(this.notification_settings, data.notification_settings, 'list_type', 'all', ['all', 'agencies', 'frameworks'])
		sdp(this.notification_settings, data.notification_settings, 'agency_list', [])
		sdp(this.notification_settings, data.notification_settings, 'framework_list', [])
	}

	comment_reads_for_save() {
		// when we save comment_reads, convert back to string format
		let s = ''
		for (let comment_id in this.comment_reads) {
			if (s != '') s += ','
			s += comment_id
		}
		return s
	}
}
window.User_Info = User_Info
